import React from 'react'

const NotFound = () => {
    return (
        <div className="flex items-center justify-center h-screen bg-gray-900 text-white">
          <h1 className="text-4xl md:text-6xl font-bold">Not Found</h1>
        </div>
      );
}

export default NotFound
